import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';

const QUILL_MODULES = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    ['link'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
  ],
};

// Explicitly allow list format so bullet/numbered list can be applied to selected text (including select-all)
const QUILL_FORMATS = [
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'link',
  'list', // block format: applies ordered/bullet to selected lines
];

const StyledQuill = styled(ReactQuill)`
  margin-top: 12px;
  background: #fff;
  border-radius: 4px;

  .ql-container.ql-snow {
    min-height: 100px;
    font-size: 14px;
  }

  .ql-editor {
    min-height: 100px;
    overflow-y: auto;
  }

  .ql-toolbar.ql-snow {
    border-radius: 4px 4px 0 0;
  }

  .ql-container.ql-snow {
    border-radius: 0 0 4px 4px;
  }
`;

export default function SubheadlineQuill({ value, onChange }) {
  const safeValue = value ?? '';

  return (
    <StyledQuill
      theme="snow"
      value={safeValue}
      onChange={(content) => onChange(content)}
      modules={QUILL_MODULES}
      formats={QUILL_FORMATS}
    />
  );
}
